
// Function to handle click events on the about-us-page #tabs li a elements
function handleTabClick(e) {
  e.preventDefault();
  var target = e.target.getAttribute('href');
  var tabs = document.querySelectorAll('.about-us-page #tabs li');
  var tabPanes = document.querySelectorAll('.about-us-page .tab-pane');

  tabs.forEach(function (tab) {
    tab.classList.remove('active');
  });

  tabPanes.forEach(function (pane) {
    pane.classList.remove('active');
  });

  document.querySelector(target).classList.add('active');
  e.target.parentElement.classList.add('active');
}

var tabLinks = document.querySelectorAll('.about-us-page #tabs li a');
tabLinks.forEach(function (link) {
  link.addEventListener('click', handleTabClick);
});

// Function to handle change events on the .tab-select.mobile elements
function handleTabSelectChange() {
  var target = this.value;
  var tabLinks = document.querySelectorAll(".about-us-page .nav-tabs li a[href='" + target + "'], .terms-conditions-page .nav-tabs li a[href='" + target + "']");

  tabLinks.forEach(function (link) {
    link.click();
  });
}

var tabSelectMobiles = document.querySelectorAll(".about-us-page .tab-select.mobile, .terms-conditions-page .tab-select.mobile");
tabSelectMobiles.forEach(function (select) {
  select.addEventListener('change', handleTabSelectChange);
});

// Function to handle click events on the .nav-tabs li a elements
function handleNavTabClick(e) {
  e.preventDefault();
  var target = e.target.getAttribute('href');
  var tabSelectMobiles = document.querySelectorAll(".about-us-page .tab-select.mobile, .terms-conditions-page .tab-select.mobile");

  tabSelectMobiles.forEach(function (select) {
    select.value = target;
  });
}

var navTabLinks = document.querySelectorAll(".about-us-page .nav-tabs li a, .terms-conditions-page .nav-tabs li a");
navTabLinks.forEach(function (link) {
  link.addEventListener('click', handleNavTabClick);
});